import StadisticTable from "../../components/StadisticTable"
import { useGetAssistersPlayers } from "./hooks/useGetAssitersPlayers"

const AssitersScreen = ()=>{
  const { assiterPlayerSort, selectedTournament} = useGetAssistersPlayers()


    return(
        <StadisticTable 
            targetName={'Asistencias'}
            title={'Tabla de asistencias'}
            tournament={selectedTournament}
            players={assiterPlayerSort}
            target={'asistencias'}

        />
    )

}

export default AssitersScreen